import AffiliateShell from "@/components/feature/AffiliateShell";
import { useWhatsApp } from "@/components/feature/useWhatsApp";

export default function Notificaciones() {
  const { status, waiting, error, activate, disable } = useWhatsApp();

  return (
    <AffiliateShell>
      <div className="max-w-xl mx-auto flex flex-col gap-4">
        <div>
          <h1 className="font-heading font-extrabold text-2xl md:text-3xl text-[#0B1F3A]">Notificaciones</h1>
          <p className="text-sm text-slate-500 mt-1">Elige cómo quieres recibir tus recordatorios.</p>
        </div>

        <section className="bg-white border border-slate-200 rounded-2xl p-5">
          <div className="flex items-start gap-3">
            <span className="w-11 h-11 rounded-full bg-[#20A464] text-white flex items-center justify-center text-2xl flex-shrink-0">
              <i className="ri-whatsapp-line"></i>
            </span>
            <div className="flex-1">
              <h2 className="font-heading font-bold text-slate-900">Avisos por WhatsApp</h2>
              <p className="text-sm text-slate-600 mt-0.5">Recordatorios de tus reuniones y eventos (un día antes y una hora antes) y avisos si se cancelan.</p>
            </div>
          </div>

          {!status ? (
            <div className="mt-4 text-sm text-slate-500">
              <i className="ri-loader-4-line animate-spin"></i> Cargando…
            </div>
          ) : status.optedIn ? (
            <div className="mt-4 flex flex-col sm:flex-row sm:items-center gap-3">
              <span className="inline-flex items-center gap-2 text-sm font-semibold text-emerald-700 bg-emerald-50 rounded-full px-3 py-1.5 self-start">
                <i className="ri-check-double-line"></i> Activados{status.phoneLast4 ? ` · número terminado en ${status.phoneLast4}` : ""}
              </span>
              <button onClick={disable} className="px-4 py-2 rounded-lg border border-slate-300 text-slate-700 text-sm font-semibold hover:bg-slate-50 cursor-pointer sm:ml-auto">
                Desactivar avisos
              </button>
            </div>
          ) : !status.number ? (
            <p className="mt-4 text-sm text-slate-500">Los avisos por WhatsApp todavía no están habilitados en tu organización.</p>
          ) : (
            <div className="mt-4">
              <button onClick={activate} disabled={waiting} className="px-5 py-2.5 rounded-lg bg-[#20A464] hover:bg-[#1b8f57] text-white text-sm font-semibold disabled:opacity-70 cursor-pointer">
                {waiting ? (
                  <>
                    <i className="ri-loader-4-line animate-spin mr-1.5"></i>Esperando tu mensaje…
                  </>
                ) : (
                  <>
                    <i className="ri-whatsapp-line mr-1.5"></i>Activar en WhatsApp
                  </>
                )}
              </button>
              <p className="mt-2 text-xs text-slate-500">
                Se abrirá WhatsApp con un mensaje listo con tu código de activación. Solo envíalo. Para dejar de recibir avisos responde STOP o desactívalos aquí.
              </p>
            </div>
          )}
          {error ? <p className="mt-3 text-sm text-rose-600">{error}</p> : null}
        </section>
      </div>
    </AffiliateShell>
  );
}
